import React, { useEffect, useState, useContext } from 'react';

import { Post } from './index'

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';

import { useSelector } from 'react-redux';

import {
  useLocation,
  useParams
} from "react-router-dom";


import {
    IdElementContext,
} from '../context';


type PropsPostsList = {
  setCurrentId?: any;
  isForm?: boolean;
  sliderDirection?: 'horizontal' | 'vertical';
  slidePerPage?: number;
  indexElement?: number
};

SwiperCore.use([Navigation, Pagination]);

const PostsList: React.FC<PropsPostsList> = ({ indexElement, slidePerPage = 1, sliderDirection = "horizontal", isForm, setCurrentId }) => {
  
  const { id } = useParams()

  // const { idElement, setIdElement } = useSharedIdElement();

   const { setIdElement } = useContext(IdElementContext);
  
  // const [postIndexElement, setPostIndexElement] = useState(0);
  //Si un post est déjà selectionné, pas pas l'affiche dans les suggestion des autres post dans postDetails 
  const posts = useSelector((state: any) => state.posts.filter(post => id ? post._id !== id : post))

  const [swiper, setSwiper] = useState(null);
  // const swiper = this.swiperRef.current.swiper;
  const slideTo = (swiper, index) => swiper.slideTo(index, 0);

  // useEffect(() => {
  //   console.log(postIndexElement)
  // }, [postIndexElement])
  // useEffect(() => {
  //   if (swiper) {
  //     setIdElement(swiper.activeIndex)
  //   }
  // }, [swiper])
  
  useEffect(() => {
    if (swiper) {
      slideTo(swiper, indexElement)
    }
  }, [swiper, indexElement]);

  return (
    <Swiper
        direction={sliderDirection}
        spaceBetween={-30}
        slidesPerView={slidePerPage}
        observer={true}
      onSlideChange={(swiper) => {
          setIdElement(swiper.activeIndex)
        }
      }
        onSwiper={(swiper) => setSwiper(swiper)}
        // onSwiper={(swiper) => console.log(swiper.activeIndex)}

      >
        {posts.map((post, i) => {
          return <SwiperSlide key={post._id}><Post isForm={isForm} setCurrentId={setCurrentId} key={post._id} post={post} /></SwiperSlide>
        })}
      </Swiper>
  );
};
export default PostsList;
